module.exports = "mutation DeleteSimpleGratuity($simpleGratuityId:ID!){deleteSimpleGratuity(simpleGratuityId:$simpleGratuityId){success}}"